import React from 'react';
import { useTemplateListingStore } from './store';

const SortableHeader = ({ children, accessor }) => {
  const { setSortColumn, sortColumn } = useTemplateListingStore();
  return (
    <div
      data-accessor={accessor}
      style={{
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
      }}
      onClick={() => setSortColumn(accessor)}
    >
      <div>
        {sortColumn.name === accessor && !sortColumn.desc && (
          <span className="material-icons">arrow_upward</span>
        )}
        {sortColumn.name === accessor && sortColumn.desc && (
          <span className="material-icons">arrow_downward</span>
        )}
      </div>
      <div>{children}</div>
    </div>
  );
};

export default SortableHeader;
